import React, { useEffect } from 'react';
import CommonInputWithIcon from '../../../components/Dashboard-res/CommonComponent/CommonInputWithIcon.js';

const InputTypeNumber = props => {
  const {
    name,
    maxLength,
    minLength,
    legendName,
    value,
    onChange,
    onBlur,
    disabled,
    error,
    errorMsg,
    touched,
    stylesContainer,
    legendStyle,
    inputStyle,
    onBlurStyle,
    setFieldValue,
    setFieldTouched,
    setFieldError,

    rupeeIcon = true,
    maxValue = ''
  } = props;

  const handleNumber = e => {
    let number = (e ? e : '')
      .toString()
      .split(',')
      .join('');
    if (!number) {
      setFieldValue(name, '');

      return;
    }
    if (!isNaN(number) || !number) {
      if (maxValue && number > maxValue) return;
      if (
        parseInt(number.length) < (maxLength ? maxLength : 0) &&
        parseInt(number.length) >= (minLength ? minLength : 0)
      ) {
        setFieldValue(name, number);
      }
    }
  };
  useEffect(() => {
    handleNumber(value);
  }, [value]);
  return (
    <div className="w-full">
      <CommonInputWithIcon
        name={name}
        legendName={legendName}
        value={value}
        onChange={e => {
          handleNumber(e.target.value);
        }}
        onBlur={onBlur}
        disabled={disabled}
        error={error}
        errorMsg={errorMsg}
        touched={touched}
        stylesContainer={stylesContainer}
        legendStyle={legendStyle}
        inputStyle={inputStyle}
        onBlurStyle={onBlurStyle}
        setFieldValue={setFieldValue}
        rupeeIcon={rupeeIcon}
      />
    </div>
  );
};

export default InputTypeNumber;
